import { atom } from 'jotai';

import { instanaReportError } from '@bizzabo/instana-api';

import { createChannelApi } from './api/createChannel';

export const showMeetingsAtom = atom(false);
export const activeChannelIdAtom = atom('');

export const createChannelAtom = atom(null, async (_, set, { members, eventId }) => {
    try {
        set(showMeetingsAtom, true);
        const data = await createChannelApi({ members }, eventId);
        set(activeChannelIdAtom, data.id);
    } catch (error) {
        instanaReportError({ error });
    }
});
